/**
 * Fonte única dos segmentos de rota da Gestão Financeira (`/gestao-financeira/**`).
 * Consumido pelo `gestao-financeira.routes.ts`, pelo menu do `gestao-financeira-content` e por todo
 * `router.navigate(...)` do módulo — renomear um caminho passa a ser um único lugar.
 */
export const GESTAO_FINANCEIRA_ROUTES = {
    ROOT: 'gestao-financeira',
    DASHBOARD: 'dashboard',
    RECEBIDOS_SINTETICO: 'valoresrecebidossintetico',
    RECEBIDOS_ANALITICO: 'valoresrecebidosanalitico',
    INADIMPLENTES_SINTETICO: 'inadimplentessintetico',
    INADIMPLENTES_ANALITICO: 'inadimplentesanalitico',
    DIVIDA_ATIVA_SINTETICO: 'dividaativasintetico',
    DIVIDA_ATIVA_ANALITICO: 'dividaativaanalitico',
    PANORAMA_CRM: 'panoramacrm',
    PESSOA: 'pessoa'
} as const;
